import PropTypes from 'prop-types';

import { trans, getResourcePath } from '@spotahome/soyuz/client';

import Hero from '@spotahome/landings-common/src/components/Hero';
import HeaderContainer from '@spotahome/landings-common/src/components/HeaderContainer';

const DEFAULT_HEADER = 'default_header.jpg';

const Header = ({
  logo = '',
  title = '',
  subtitle = '',
  image = DEFAULT_HEADER
}) => {
  const imageUrl = getResourcePath(
    `/images/institution/${image || DEFAULT_HEADER}`
  );

  return (
    <Hero
      menu={<HeaderContainer />}
      backgroundImage={`url(${imageUrl})`}
      opacity
    >
      <Hero.TitleWrapper>
        {logo && <img src={logo} alt={title} />}

        <span className="institution-info-about">
          {trans('landingpage.label.info_about')}
        </span>

        <Hero.Title>{title}</Hero.Title>
        <Hero.SubTitle>{subtitle}</Hero.SubTitle>
      </Hero.TitleWrapper>
    </Hero>
  );
};

Header.propTypes = {
  logo: PropTypes.string,
  title: PropTypes.string,
  subtitle: PropTypes.string,
  image: PropTypes.string
};

export default Header;
